import React from 'react';
import { ContentBlockCard, Section } from '@components';
import { Button } from '@mui/material';
import { AddRounded } from '@mui/icons-material';

const Services = ({ services }) => {
  return (
    <Section className={'pt-8 pb-28'}>
      {services.map(({ attributes }, i) => {
        const { name, img, description, cta } = attributes;
        return (
          <ContentBlockCard index={i} key={i} img={img}>
            <div className="px-4 space-y-2">
              <p className="h2 text-primary">{name}</p>

              <p className="body">{description}</p>
              <Button href={cta?.href}>
                <AddRounded className="mr-1" />{' '}
                <span>{cta?.label}</span>
              </Button>
            </div>
          </ContentBlockCard>
        );
      })}
    </Section>
  );
};

export default Services;
